import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TAttachmentsStore,
	TAttachmentTypesResponsePayload,
	TEmAttachmentsListRequest,
	TEmAttachmentsListResponsePayload,
	TEmAttachmentUploadRequest,
	TEmAttachmentDownloadRequest,
	TEmAttachmentDeleteRequest,
	TEmAttachmentDownloadByAttachmentIdRequest,
	TGenerateUploadLinkRequest,
	TGenerateUploadLinkResponsePayload,
} from './types';

const initialState: TAttachmentsStore = {
	attachmentTypes: null,
	attachmentTypesLoading: false,
	emAttachments: null,
	emAttachmentsLoading: false,
	uploadLoading: false,
	downloadLoading: false,
	deleteLoading: false,
	generateUploadLinkLoading: false,
	generateUploadLinkResult: null,
};

const attachments = createSlice({
	name: '@@attachments',
	initialState,
	reducers: {
		getAttachmentTypesRequest: (state: TAttachmentsStore) => {
			const s = state;
			s.attachmentTypesLoading = true;
		},
		getAttachmentTypesSuccess: (
			state: TAttachmentsStore,
			action: PayloadAction<TAttachmentTypesResponsePayload>,
		) => {
			const s = state;
			s.attachmentTypes = action.payload;
			s.attachmentTypesLoading = false;
		},

		getEmAttachmentsRequest: (
			state: TAttachmentsStore,
			action: PayloadAction<TEmAttachmentsListRequest>,
		) => {
			const s = state;
			s.emAttachmentsLoading = true;
		},
		getEmAttachmentsSuccess: (
			state: TAttachmentsStore,
			action: PayloadAction<TEmAttachmentsListResponsePayload>,
		) => {
			const s = state;
			s.emAttachments = action.payload;
			s.emAttachmentsLoading = false;
		},

		uploadEmAttachmentRequest: (
			state: TAttachmentsStore,
			action: PayloadAction<TEmAttachmentUploadRequest>,
		) => {
			const s = state;
			s.uploadLoading = true;
		},
		uploadEmAttachmentSuccess: (state: TAttachmentsStore) => {
			const s = state;
			s.uploadLoading = false;
		},

		downloadEmAttachmentRequest: (
			state: TAttachmentsStore,
			action: PayloadAction<TEmAttachmentDownloadRequest>,
		) => {
			const s = state;
			s.downloadLoading = true;
		},
		downloadEmAttachmentSuccess: (state: TAttachmentsStore) => {
			const s = state;
			s.downloadLoading = false;
		},
		downloadAttachmentByAttachmentIdRequest: (
			state: TAttachmentsStore,
			action: PayloadAction<TEmAttachmentDownloadByAttachmentIdRequest>,
		) => {
			const s = state;
			s.downloadLoading = true;
		},
		downloadAttachmentByAttachmentIdSuccess: (state: TAttachmentsStore) => {
			const s = state;
			s.downloadLoading = false;
		},
		deleteEmAttachmentRequest: (
			state: TAttachmentsStore,
			action: PayloadAction<TEmAttachmentDeleteRequest>,
		) => {
			const s = state;
			s.deleteLoading = true;
		},
		deleteEmAttachmentSuccess: (state: TAttachmentsStore) => {
			const s = state;
			s.deleteLoading = false;
		},

		generateUploadLinkRequest: (
			state: TAttachmentsStore,
			action: PayloadAction<TGenerateUploadLinkRequest>,
		) => {
			const s = state;
			s.generateUploadLinkLoading = true;
			s.generateUploadLinkResult = null;
		},
		generateUploadLinkSuccess: (
			state: TAttachmentsStore,
			action: PayloadAction<TGenerateUploadLinkResponsePayload>,
		) => {
			const s = state;
			s.generateUploadLinkLoading = false;
			s.generateUploadLinkResult = action.payload;
		},
		resetGenerateUploadLink: (state: TAttachmentsStore) => {
			const s = state;
			s.generateUploadLinkLoading = false;
			s.generateUploadLinkResult = null;
		},
	},
});

export default attachments.reducer;

export const {
	getAttachmentTypesRequest,
	getAttachmentTypesSuccess,
	getEmAttachmentsRequest,
	getEmAttachmentsSuccess,
	uploadEmAttachmentRequest,
	uploadEmAttachmentSuccess,
	downloadEmAttachmentRequest,
	downloadEmAttachmentSuccess,
	deleteEmAttachmentRequest,
	deleteEmAttachmentSuccess,
	downloadAttachmentByAttachmentIdRequest,
	downloadAttachmentByAttachmentIdSuccess,
	generateUploadLinkRequest,
	generateUploadLinkSuccess,
	resetGenerateUploadLink,
} = attachments.actions;
